module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Other Common Overseas")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto",
    attrs: {
      "center": ""
    }
  }, [_c('b-nav-form', [_c('b-button', {
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsReverse('Others_Common_Overses_EXCEL', 'Export')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard')], 1)], 1)], 1), _vm._v(" "), _c('b-card', [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": "Select To"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.ToFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ToFilter", $$v)
      },
      expression: "Filter.ToFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date :")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PORfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORfilter", $$v)
      },
      expression: "Filter.PORfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.PODfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODfilter", $$v)
      },
      expression: "Filter.PODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.containerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "containerTypeFilter", $$v)
      },
      expression: "Filter.containerTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.shippingLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shippingLineFilter", $$v)
      },
      expression: "Filter.shippingLineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Air Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirLineList'],
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Air Line"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.airLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "airLineFilter", $$v)
      },
      expression: "Filter.airLineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "payVal",
      "option-text": "payText",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.shipmentTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shipmentTypeFilter", $$v)
      },
      expression: "Filter.shipmentTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("MANIFESTATION STATUS")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ManifestationStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Manifestation"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("CLOSE STATUS")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CLosedStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Close Status"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.closedFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "closedFilter", $$v)
      },
      expression: "Filter.closedFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search (Assignment No. / Client / Container No. / Shipping Line / BL NO / CR/DR NO / HBL )"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.CommonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "CommonFilter", $$v)
      },
      expression: "Filter.CommonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-4"
  })], 1), _vm._v(" "), _c('b-row', {
    staticClass: "align-content-end mt-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.Others_Common_Overses_data,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "common_over_id",
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "common_over_id",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n              " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n            ")])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row4) {
        return [_c('span', [_vm._v("\n              Ass No:\n              "), _c('b', [_vm._v(_vm._s(row4.item.mainSalesSeries))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Ass Date:\n              "), _c('b', [_vm._v(_vm._s(row4.item.assDate))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Raised From:\n              "), _c('b', [_vm._v(_vm._s(row4.item.raisedFrom))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Raised By:\n              "), _c('b', [_vm._v(_vm._s(row4.item.raiesdBy))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Ass Type:\n              "), _c('b', [_vm._v(_vm._s(row4.item.over_Transport_Type +
          " ( " +
          row4.item.over_shipmentType +
          " )"))])]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "over_type",
      fn: function(row2) {
        return [_c('span', {
          attrs: {
            "variant": "info"
          }
        }, [_c('b', [_vm._v("\n                " + _vm._s(row2.item.over_type) + "\n              ")])]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "agent_coloder_txt",
      fn: function(row3) {
        return [_c('span', {
          attrs: {
            "variant": "info"
          }
        }, [_c('b', [_vm._v(_vm._s(row3.item.agent_coloder_txt))])]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "POR",
      fn: function(row3) {
        return [(row3.item.over_shipmentType == 'Sea') ? _c('span', {
          attrs: {
            "variant": "info"
          }
        }, [_c('b', [_vm._v(_vm._s("Stuffing : " + row3.item.STUFF))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s("Handover : " + row3.item.HAND))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s("Pickup : " + row3.item.PICK))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s("LP : " + row3.item.POL))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s("POR : " + row3.item.POR))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s("POD : " + row3.item.POD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s("FPOD : " + row3.item.FPOD))]), _vm._v(" "), _c('br')]) : (row3.item.over_shipmentType == 'Sea') ? _c('span', {
          attrs: {
            "variant": "info"
          }
        }, [_c('b', [_vm._v(_vm._s("Departure Airport : " + row3.item.AirDept))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s("Destination Airport : " + row3.item.airDesti))])]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "MBLNO",
      fn: function(row4) {
        return [_c('b', [_vm._v(_vm._s("MBL NO.:-" + row4.item.MBLNO))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s("HBL NO.:-" + row4.item.HBLNO))]), _vm._v(" "), _c('br'), _vm._v(" "), (row4.item.containerNo != null) ? _c('div', [_c('b', [_vm._v(_vm._s("CONT NO.:-"))]), _vm._v(" "), _vm._l((row4.item.containerNo.split(',')), function(item, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item + " "))])], 1)])
        })], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s("CONT TYPE.:-" + row4.item.containerType))]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "CountmainManifestationData",
      fn: function(row6) {
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": row6.item.CountmainManifestationData == 0 ?
              'outline-danger' :
              'outline-success'
          },
          on: {
            "click": function($event) {
              row6.item.CountmainManifestationData != 0 ?
                _vm.sendCommonManifestation(row6.item) :
                ''
            }
          }
        }, [_vm._v(_vm._s(row6.item.CountmainManifestationData == 0 ? "Pending" : "Received"))]), _vm._v(" "), (row6.item.newManiFestCount > 0) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("New Manifestation\n                " + _vm._s(row6.item.newManiFestCount))]), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((row6.item.NoteDetails), function(CDitem, CD_index) {
          return _c('span', {
            key: CD_index
          }, [(CDitem.uploadCreditDebit != '' && CDitem.approvalStatus == '1') ? _c('b-badge', {
            staticClass: "p-2 ml-2 mt-2",
            attrs: {
              "variant": "warning",
              "size": "sm"
            },
            on: {
              "click": function($event) {
                _vm.PrintNote(row6.item.mainSalesSeries, CDitem.uploadCreditDebit)
              }
            }
          }, [_c('span', [_vm._v(_vm._s(CDitem.creditDebitNoteType == 2 ? "Debit" : "Credit") + " PDF")])]) : _vm._e()], 1)
        })]
      }
    }, {
      key: "action",
      fn: function(row5) {
        return [_c('span', [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": row5.item.over_closedOverseas_status == 1 ?
              'outline-danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row5.item.over_closedOverseas_status == 1 ?
                _vm.openCloseOverseasModal(row5.item) :
                ''
            }
          }
        }, [_vm._v(_vm._s(row5.item.over_closedOverseas_status == 1 ? "Close" : "Closed"))]), _vm._v(" "), _c('br'), _vm._v(" "), (row5.item.over_closedOverseas_status == 0) ? _c('span', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("\n                User:" + _vm._s(row5.item.closedOverseas_byuser) + "\n                "), _c('br'), _vm._v("\n                Date:" + _vm._s(row5.item.closedOverseas_created_at) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _vm._l((row5.item.NoteDetails), function(CDitem, CD_index) {
          return _c('span', {
            key: CD_index
          }, [(
            _vm.$sessionsStorage.get('designation') == 'Admin' &&
            _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' && CDitem.noteSeries
          ) ? _c('EditCRDRNote', {
            attrs: {
              "title": 'Edit ' +
                (CDitem.creditDebitNoteType === '2' ? 'Debit' : 'Credit') +
                ' Note : ' +
                CDitem.noteSeries,
              "note_id": CDitem.note_id,
              "noteSeries": CDitem.noteSeries,
              "note_page": CDitem.page,
              "AgentType": CDitem.agentType,
              "creditDebitNoteType": CDitem.creditDebitNoteType,
              "approvalStatus": CDitem.approvalStatus,
              "uploadCreditDebit": CDitem.uploadCreditDebit,
              "creditDebitNote_Status": CDitem.creditDebitNote_Status,
              "JOBID": row5.item.allModuleId,
              "JOBNO": row5.item.mainSalesSeries,
              "JOBDATE": row5.item.assDate,
              "JOBTYPE": row5.item.over_Jobtype
            }
          }) : _vm._e()], 1)
        }), _vm._v(" "), _c('Overseas-CRDRNote', {
          attrs: {
            "title": row5.item.mainSalesSeries,
            "moduleType": row5.item.over_moduleType,
            "cr_all_module_id": row5.item.allModuleId,
            "cr_jb_series": row5.item.mainSalesSeries,
            "cr_ass_date": row5.item.assDate,
            "transportType": row5.item.over_Transport_Type,
            "Jobtype": row5.item.over_Jobtype,
            "commonId": row5.item.over_common_id || '0',
            "shipmentType": row5.item.over_shipmentType,
            "isOverseas": true,
            "ItemAr": row5.item
          }
        }), _vm._v(" "), (row5.item.over_closedOverseas_status == '0') ? _c('CommonOverseaUnLock', {
          attrs: {
            "title": 'Open ' + row5.item.Overlock_module_type + ' Assignment',
            "Overlock_item": row5.item,
            "Overlock_JOBNO": row5.item.mainSalesSeries,
            "Overlock_allModuleId": row5.item.allModuleId,
            "Overlock_table_name": 'common_Overses',
            "Overlock_table_key": 'common_over_id',
            "Overlock_table_value": row5.item.common_over_id,
            "Overlock_column_key": 'closedOverseas_status',
            "Overlock_column_value": row5.item.over_closedOverseas_status,
            "Overlock_module_type": row5.item.Overlock_module_type
          }
        }) : _vm._e(), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row5.item.allModuleId,
            "fk_client_id": row5.item.clientId,
            "fk_pod_id": row5.item.PODLocationId
          }
        }), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row5.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "assign_date": _vm._f("moment")(row5.item.loginTime),
            "assign_job_type": row5.item.jobType,
            "assign_raised_from": 'Raised From: ' + row5.item.raisedFrom,
            "assign_raised_by": 'Raised By: ' + row5.item.raiesdBy,
            "fk_all_module_id": row5.item.allModuleId,
            "jb_series": row5.item.mainSalesSeries,
            "fk_client_id": row5.item.clientId,
            "fk_pod_id": row5.item.PODLocationId
          }
        }), _vm._v(" "), (row5.item.SplitedStatus != '0') ? _c('Splitmerge-Summary', {
          staticClass: "mt-2",
          attrs: {
            "title": 'Split & Merge Track - ',
            "SM_all_module_id": row5.item.allModuleId,
            "SM_jb_series": row5.item.mainSalesSeries,
            "SM_Status": 1
          }
        }) : _vm._e(), _vm._v(" "), (row5.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row5.item.mainSalesSeries,
            "PMC_JOBID": row5.item.allModuleId.toString(),
            "PMC_JOBNO": row5.item.mainSalesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row5.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row5.item.mainSalesSeries,
            "PMC_JOBID": row5.item.allModuleId,
            "PMC_JOBNO": row5.item.mainSalesSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('h5', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "8",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('b-modal', {
    ref: "CloseOverseas-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "md",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h3', [_vm._v("Are you sure to want close")])]), _vm._v(" "), _c('center', [_c('span', {
    staticClass: "center"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.SaveCloseOverseas
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideCloseOverseasModal
    }
  }, [_vm._v("No")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-460fd296","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Overseas/otherCommonOverseas.vue
// module id = 2575
// module chunks = 0